import angular from 'angular';
import { MovimentacoesListagemController } from './movimentacoes-listagem.controller';

export class MovimentacoesListagemComponent implements angular.IComponentOptions {
    static selector = 'movimentacoesListagem';
    static controller = MovimentacoesListagemController;
    static template = require('!!html-loader!./movimentacoes-listagem.component.html');
    static bindings = {
        selectedPeriod: '<',
        workflowEnabled: '<',
        canManage: '<',
        currentUserEmail: '<',
        refreshRequest: '<',
        onOpenDetail: '&',
        onChanged: '&?'
    };
}
